import { styled } from "@mui/material";

export const RateTreeItemEmptyContentInteractionLayer = styled("div")(({ theme }) => ({
  zIndex: 1000,
  width: "100%",
  height: theme.spacing(1),
  position: "absolute",
}));
